<template>
    <div>
        <v-card>
            <v-card-title class="font-weight-black black--text">
                {{$t('user.changePassword')}}
            </v-card-title>
            <v-card-subtitle class="black--text">
                {{$t('user.goodIdeaToUsePassword')}}
            </v-card-subtitle>
            <v-form
                ref="psw_form"
                v-model="valid"
                lazy-validation
                @submit.prevent="updatePassword"
            >
            <v-card-text width="100%">
                <v-row>	
                    <v-col cols="6">
                        <v-card flat>
                            <v-card-text>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                    >
                                        <label class="subtitle-1 font-weight-medium black--text" for="Current Password">{{$t('user.currentPassword')}}</label>
                                        <v-text-field
                                            type="password"
                                            v-model="oldPassword"
                                            outlined
                                            dense
                                            :placeholder="$t('user.enterCurrentPassword')"
                                            :rules="rules.oldPsw"
                                            :error-messages="errors.oldPassword"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        class="mt-n8"
                                    >
                                        <label class="subtitle-1 font-weight-medium black--text" for="note">{{$t('user.newPassword')}}</label>
                                        <v-text-field
                                            type="password"
                                            v-model="newPassword"
                                            outlined
                                            dense
                                            :placeholder="$t('user.enterNewPassword')"
                                            :rules="rules.newPsw"
                                            :counter="6"
                                            :error-messages="errors.newPassword"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        class="mt-n8"
                                    >
                                        <label class="subtitle-1 font-weight-medium black--text" for="note">{{$t('user.repeatNewPassword')}}</label>
                                        <v-text-field
                                            type="password"
                                            v-model="confirmPassword"
                                            outlined
                                            dense
                                            :placeholder="$t('user.reEnterPassword')"
                                            :rules="[ matchingPasswords]"
                                            :counter="6"
                                            :error-messages="errors.confirmPassword"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                        
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col class="pt-10 text-center" cols="6"></v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" right height="44" width="116" color="primary">
                        {{ $t('update') }}
                    </v-btn>
                </v-card-actions>
            </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>
<script>
import loading from "@/mixins/LoadingMixin";
import ProfileService from "../../_services/ProfileService";

export default {
    data: () => ({
        errors: { oldPassword: '',newPassword: '',confirmPassword: ''},
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        valid: true,
        rules: {
            oldPsw: [
                v => !!v || this.$t('user.pleaseTypeOldPassword')
            ],
            newPsw: [
                v => !!v || this.$t('user.pleaseTypeNewPassword'),
                v => (v && v.length >= 6) || 'minimum 6 characters',
            ],
            confPsw: [
                v => !!v || this.$t('user.pleaseTypeConfirmPassword'),
            ]
        }
    }),
    methods: {
        updatePassword() {
            this.errors.oldPassword, this.errors.newPassword, this.errors.confirmPassword = ''
            if(!this.$refs.psw_form.validate()) return;
            this.startLoading();
            ProfileService.updatePassword({
                oldPassword: this.oldPassword,
                newPassword: this.newPassword,
                confirmPassword:this.confirmPassword
            })
            .then((res) => {
                console.log(res)
                this.$notify({
                    title: this.$t('user.passwordChangedSuccesFully'),
                    text: ``,
                    type: 'success'
                });
                this.stopLoading()
            })
            .catch((error) => {
                if(error.status == 422){
					error.data.message.errors.forEach(err => {
						this.errors[err.param] = err.msg
					});
				}
                this.$notify({
                    title: this.$t('somethingWentWrong'),
                    text: this.$t('pleaseTryAgainAfterSometime'),
                    type: 'error'
                });
                this.stopLoading()
            })
        },
        matchingPasswords(){
            if(this.confirmPassword.length < 1) return this.$t("user.pleaseTypeConfirmPassword")

            return (this.newPassword === this.confirmPassword) ? true : this.$t('user.passwordDoesNotMatch');
        }
    },
    mixins: [loading]
}
</script>
